import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { BASE_API_URL } from '../Config';
import useAuthentication from '../service/AuthenticationService';

const instance = axios.create({
    timeout: 30_000,
    headers: {
        'Content-Type': 'application/json',
    },
});

export function useProfile() {
    const authentication = useAuthentication();

    return useQuery({
        queryKey: ['profile'],
        queryFn: async () => {
            const results = await instance.get(BASE_API_URL + '/profile', {
                headers: {
                    Authorization: 'Bearer ' + authentication.token,
                },
            });
            return results.data;
        },
        enabled: authentication.isLogged,
        staleTime: 1000 * 60 * 5,
    });
}
